export const DEFAULT_OPPORTUNITY_IMAGE = '/default.svg'
